import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import styled  from 'styled-components';

import COLORS from '@mlb/react-patterns/style/universal.color';
import Button from '@mlb/react-patterns/components/Button/button.tsx';

import { Tracking } from 'bdvp-tracking';

import useNodeQuery from '../../hooks/useNodeQuery';
import { useDictionary, useLang } from '../../hooks/config';
import Content from './Content';

const Container = styled.div`
    position: relative;
    display: block;
    background-color: ${COLORS.mlbGrey7};
    border-radius: 5px;
    overflow: hidden;
`;

const DismissButton = styled(Button)`
    position: absolute;
    right: 5px;
`;

const Notification = ({
    contentConfig,
    onDismiss,
    className,
    ...otherProps
}) => {

    const [
        matches,
        ref,
    ] = useNodeQuery();
    const dictionary = useDictionary();
    const lang = useLang();
    const history = useHistory();

    for (const size in matches) {

        if(matches[size]) {

            className += ` ${size}`;

        }

    }

    useEffect(() => {

        Tracking.trackUserEducationImpression();

    }, []);

    const onDismissNotification = () => {

        Tracking.trackUserEducationCloseButtonClick();
        onDismiss();

    };

    const onGetStartedClick = () => {

        Tracking.trackUserEducationGetStartedClick();
        if (history.location.pathname === '/') {

            return;

        }

        history.push({
            pathname: '/',
        });
    
    };

    return (
        <Container
            ref={ref}
            className={className}
            {...otherProps}
        >
            <DismissButton
                iconName={'close'}
                size={'md'}
                handlers={{
                    onClick: onDismissNotification,
                }}
                styleName={'default'}
                shape={'hollow-borderless'}
                ariaLabel={dictionary.dismiss ?? 'Dismiss'}
            />
            <Content
                config={contentConfig}
                matches={matches}
                lang={lang}
                onGetStartedClick={onGetStartedClick}
            />
        </Container>
    );

};

Notification.propTypes = {
    contentConfig: PropTypes.object.isRequired,
    onDismiss: PropTypes.func.isRequired,
    className: PropTypes.string,
};

Notification.defaultProps = {
    className: '',
};

export default Notification;
